































































































import {
  SfCharacteristic,
  SfHeading,
  SfProperty,
  SfPrice,
  SkeletonLoader,
  SfQuantitySelector,
  SfCollectedProduct, SfLoader, SfImage, SfBadge
} from '~/components';
import { computed, defineComponent } from '@nuxtjs/composition-api';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import { useCart, useCartView, useWebsiteCode } from '~/composables';
import getShippingMethodPrice from '~/helpers/checkout/getShippingMethodPrice';

export default defineComponent({
  name: 'CartPreview',
  head() {
    return {
      title: this.$i18n.t('Checkout') as string
    };
  },
  components: {
    SfBadge,
    SfImage,
    SfLoader,
    SfCollectedProduct,
    SfQuantitySelector,
    SkeletonLoader,
    SfHeading,
    SfProperty,
    SfCharacteristic,
    SfPrice,
  },
  setup() {
    const { cart } = useCart();
    const cartView = useCartView();

    const {
      isMe,
      isUs,
      isInt
    } = useWebsiteCode();

    const products = computed(() => cartGetters.getItems(cart.value));
    const giftWrap = computed(() => cartGetters.getGiftWrap(cart.value));
    const totalItems = computed(() => cartGetters.getTotalItems(cart.value));
    const totals = computed(() => cartGetters.getTotals(cart.value));
    const selectedShippingMethod = computed(() => cartGetters.getSelectedShippingMethod(cart.value));

    return {
      cart,
      ...cartView,
      isInt,
      isUs,
      isMe,
      totalItems,
      products,
      giftWrap,
      totals,
      cartGetters,
      getShippingMethodPrice,
      selectedShippingMethod,
    };
  },
});
